import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import { XOKButton } from '@/components/xqxc_ui';

const Plary = ({
    modalParam = '',
    closeModal
}) => {
    const footerNode = <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <XOKButton
            label='确定'
            onClick={closeModal}
        />
    </div>;
    return <Modal
        width={360}
        centered
        title='播放'
        visible={true}
        onCancel={closeModal}
        destroyOnClose={true}
        keyboard={true}
        maskClosable={false}
        footer={footerNode}
    >
        <audio controls src={modalParam}>
            您的浏览器不支持 audio 元素。
        </audio>
    </Modal>;
};
Plary.proptypes = {
    modalParam: PropTypes.string,
    closeModal: PropTypes.func
};
export default Plary